import { Directive } from '@angular/core';
import { provideJsonEditor } from '@examdojo/core/json-editor';
import echartsOptionSchema from '@settings/echarts_option_schema.json';

@Directive({
  selector: '[dojoCustomComponentJsonEditor]',
  providers: [provideJsonEditor(echartsOptionSchema, 'custom-component')],
  standalone: true,
})
export class CustomComponentJsonEditorDirective {}
